import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "loading",
  "use": "loading-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 100 100\" id=\"loading\"><circle cx=\"50\" cy=\"50\" r=\"35\" fill=\"none\" transform=\"rotate(132 50 50)\"><animateTransform attributeName=\"transform\" begin=\"0s\" calcMode=\"linear\" dur=\"1s\" from=\"0 50 50\" keyTimes=\"0;1\" repeatCount=\"indefinite\" to=\"360 50 50\" type=\"rotate\" /></circle></symbol>"
});
var result = sprite.add(symbol);
export default symbol